import {
  Box,
  Flex,
  JaneGoldIcon,
  TagFilledIcon,
  Typography,
} from '@iheartjane/reefer';

/** Props for the CTA callout banner within the special detail status */
export interface SpecialDetailStatusCTAProps {
  /** Secondary text below the callout (e.g., "$5 cash back each") */
  calloutSubtext?: string;
  /** Primary callout message (e.g., "Add up to 2 more products") */
  calloutText: string;
  /** Whether this is a Jane Gold special */
  isGold: boolean;
}

export const SpecialDetailStatusCTA = ({
  calloutSubtext,
  calloutText,
  isGold,
}: SpecialDetailStatusCTAProps) => {
  if (!calloutText) return null;

  return (
    <Flex alignItems="center">
      <Box
        background={isGold ? 'gold-light' : 'info-light'}
        borderRadius="xs"
        p={12}
      >
        {isGold ? <JaneGoldIcon /> : <TagFilledIcon color="info" />}
      </Box>

      <Box ml={16}>
        <Typography variant="body-semibold">{calloutText}</Typography>
        {calloutSubtext && (
          <Typography variant="small-body-regular" color="grays-mid">
            {calloutSubtext}
          </Typography>
        )}
      </Box>
    </Flex>
  );
};
